/* eslint-disable import/prefer-default-export */
import makeApiCall from './makeApiCall';

export const getDepartmentFilter = (params) =>
  makeApiCall(`/filter/v3/departments`, 'POST', params, false);

export const getTeamFilter = (params) => makeApiCall(`/filter/v3/teams`, 'POST', params, false);

export const getTeamV4Filter = (params) =>
  makeApiCall(`/filter/v3/rep-teams`, 'POST', params, false);

export const getHeadFilter = (params) => makeApiCall(`/filter/v3/heads`, 'POST', params);

export const getManagerFilter = (params) => makeApiCall(`/filter/v3/managers`, 'POST', params);

export const getRepFilter = (params) => makeApiCall(`/filter/v3/reps`, 'POST', params);

export const getDoctorFilter = (params) => makeApiCall(`/filter/v3/doctors`, 'POST', params);

export const getGroupFilter = (params) => makeApiCall(`/filter/v3/groups`, 'POST', params);

export const getSpecialtyFilter = (params) => makeApiCall(`/filter/v3/specialties`, 'POST', params);

/// MULTI

export const getAgendaFilter = (params) => makeApiCall(`/agendas/list`, 'GET', params);

export const getProgramFilter = (params) =>
  makeApiCall(`/marketing_materials/programs/list`, 'POST', params);

export const getMaterialsFilter = (params) =>
  makeApiCall(`/marketing_materials/materials/list`, 'POST', params);
